import React from "react";

export default function FormattedDate (props){
   
let days= [
    "Sunday", 
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday", 
    "Saturday",
    "Sunday"
    ]
    let day = days[props.date.getDay()];
    let hours = props.date.getHours();
    let minutes = props.date.getMinutes();

    if  (minutes < 10 ){
        minutes = `0${minutes}`;
    }

    return (<div>
        {day} {hours}:{minutes}
        
        </div>);
}